<template>
  <div class="base-content">
    <query-frame
      :pageVisible="false"
      :current="page.current"
      :total="page.total"
      @on-query="handleQuery"
      @on-reset="handleReset"
      @on-add="handleAdd"
      @on-page-change="handlePageChange"
      @on-size-change="handleSizeChange"
    >
      <!-- 查询条件开始 -->
      <template slot="query">
        <query-item label="状态">
          <a-select allowClear v-model="query.status">
            <a-select-option :value="0">
              启用
            </a-select-option>
            <a-select-option :value="1">
              禁用
            </a-select-option>
          </a-select>
        </query-item>
      </template>
      <!-- 查询条件结束 -->

      <!-- 查询结果 开始 -->
      <template slot="table">
        <i-table :columns="columns" :dataSource="dataList">
        </i-table>
      </template>
      <!-- 查询结果 结束 -->
    </query-frame>
  </div>
</template>

<script>
import { timesCardList, timesCardStatus, deleteTimesCardById } from '@/api/timesCard';
import queryMixin from '@/mixin/queryMixin';

export default {
  name: 'timesCardType',
  mixins: [queryMixin],
  props: {},
  data() {
    return {
      query: {
        status: null,
        timesCardName: null,
      },
      // 默认展示表格
      columns: [
        {
          title: '序号',
          width: 80,
          customRender(text, item, index) {
            return index + 1;
          }
        },
        {
          title: '门店名称',
          dataIndex: 'shopName',
          key: 'shopName',
          width: 300,
        },
        {
          title: '次卡名称',
          dataIndex: 'timesCardName',
          key: 'timesCardName',
          width: 300,
        },
        {
          title: '次数',
          dataIndex: 'count',
          key: 'count',
        },
        {
          title: '状态',
          dataIndex: 'status',
          key: 'status',
          customRender: (text, row) => {
            return (
              <a-switch checked-children="启用" un-checked-children="禁用" checked={row.status === 0} onClick={ () => this.handleStatus(row)}/>
            );
          }
        },
        {
          title: '操作',
          dataIndex: 'action',
          key: 'action',
          fixed: 'right',
          width: 200,
          scopedSlots: { customRender: 'action' },
          customRender: (text, row) => {
            return (
              <section>
                <a-button type="link" size="small" onClick={ () => this.handleEdit(row) }>修改</a-button>
                <a-divider type="vertical"></a-divider>
                <a-button type="link" size="small" onClick={ () => this.handleDelete(row) }>删除</a-button>
              </section>
            );
          }
        }
      ],
      dictOptions: {},
      dataList: []
    };
  },
  created() {
    this.handleQuery();
  },
  methods: {
    // 获取列表
    getData() {
      this.dataList = [];
      timesCardList(this.params).then((data) => {
        data.forEach((item) => {
          item.key = item.timesCardId;
          // if (item.startDate) {
          //   item.startDate = formatDate(item.startDate);
          // }
          // if (item.endDate) {
          //   item.endDate = formatDate(item.endDate);
          // }
        });
        this.dataList = data;
        // console.log(this.dataList)
      });
    },

    // 添加
    handleAdd() {
      this.$router.push({
        name: 'timesCardTypeAdd'
      });
    },
    // 编辑
    handleEdit(row) {
      this.$router.push({
        name: 'timesCardTypeEdit',
        params: {
          id: row.timesCardId
        }
      });
    },
    // 编辑
    handleDelete(row) {
      const self = this;
      this.$confirm({
        title: '删除次卡类型',
        content: '此操作将永远删除该车次卡类型，您确定要这么做吗？',
        okType: 'danger',
        onOk() {
          return new Promise((resolve, reject) => {
            console.log(row.timesCardId);
            deleteTimesCardById(row.timesCardId).then(() => {
              self.$message.success('删除成功');
              self.getData();
              resolve();
            }).catch(() => {
              reject();
            });
          }).catch((e) => console.log(e));
        },
        onCancel() {},
      });
    },
    // 启用或者禁用
    handleStatus(row) {
      const params = {
        timesCardId: row.timesCardId,
        status: row.status === 0 ? 1 : 0
      };
      console.log(params);

      timesCardStatus(params).then(() => {
        this.$message.success('操作成功！');
        this.getData();
      });
    },
  }
};
</script>

<style lang="less" scoped>

</style>
